import { saveChatSession } from './saveChatSession'

/** @type {ChatSession} */
const newSession = {
  chatId: '',
  chatActive: false,
  conversation: [],
  groupId: 13,
  rating: -1,
  users: [],
  welcomeMessage:
    "Hi! Your results are ready! What's your full name so I can pull up your form?",
}

/**
 * Deletes Chat Session
 */
export function deleteChatSession() {
  localStorage.removeItem('TD_LC_CHAT_SESSION')
  saveChatSession(newSession)
}
